var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsaa = function SvgUsaa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "usaa_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".usaa_svg__st1{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b3359"
    },
    d: "M0 0h40v26H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "usaa_svg__Calque_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.117 16.315v2.925c0 1.625 1.04 1.885 1.885 1.885 1.235 0 1.82-.78 1.82-1.885v-2.86h-.845v2.925c0 .39-.13 1.105-.975 1.04-.78 0-.975-.715-.975-1.17v-2.86h-.91zm7.085.195s-.52-.26-1.105-.26c-.715 0-1.69.39-1.69 1.43 0 .715.52 1.04.91 1.235.195.065.455.195.65.325.13.065.52.195.52.585 0 .455-.52.585-.715.585-.78 0-1.365-.39-1.365-.39l.065.91s.325.195 1.3.195c.91 0 1.625-.585 1.625-1.43 0-.65-.455-.975-.78-1.17a7.625 7.625 0 0 1-.715-.325c-.26-.13-.52-.325-.52-.65s.325-.585.78-.585c.715 0 .975.325 1.105.39l-.065-.845zm6.63-.195h-.975l.13.39-1.56 3.965-1.495-4.355h-.975l.13.39-1.625 4.225h.91l.26-.845h1.69l.26.845h1.69l.26-.845h1.69l.26.845h.975l-1.625-4.615zm-4.94 3.12.65-1.82.585 1.82h-1.235zm3.9 0 .65-1.82.585 1.82h-1.235zM12.052 11.05l.065 1.495s.39-.26.78-.26.845.26.845.26l3.64 2.08.325-1.3-3.965-2.275s-.455-.26-.845-.26c-.39 0-.845.26-.845.26",
    className: "usaa_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.052 9.165.065 1.495s.39-.26.78-.26.845.26.845.26l4.03 2.34.325-1.3-4.355-2.535s-.455-.26-.845-.26c-.39 0-.845.26-.845.26",
    className: "usaa_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.052 7.215.065 1.495s.39-.26.78-.26.845.26.845.26l4.42 2.535.325-1.3-4.745-2.73s-.455-.26-.845-.26c-.39 0-.845.26-.845.26",
    className: "usaa_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.657 5.005.39 1.755 5.525 3.12s.455.26.845.26c.455 0 .845-.325.845-.325v-1.43s-.325.26-.78.26-.845-.26-.845-.26l-4.29-2.47-.325-1.105c0-.065.065-.065.065-.065l.715-.195c.13.065.13.13.13.195l.065.065.13-.065V4.29c0-.325-.26-.52-.52-.52h-.715s-.13-.26-.39-.26h-1.365c-.39 0-.455.325-.455.325l-1.04 3.77-3.9-2.275s-.455-.26-.845-.26c-.455 0-.845.325-.845.325l.065 1.495s.325-.26.78-.26.845.26.845.26l4.81 2.795 1.105-4.68z",
    className: "usaa_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.177 7.085.39 1.755 5.005 2.925s.455.26.845.26.845-.325.845-.325v-1.43s-.325.26-.78.26-.845-.26-.845-.26l-5.46-3.185z",
    className: "usaa_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.697 9.36.39 1.755 4.485 2.6s.455.26.845.26c.39 0 .845-.325.845-.325v-1.43s-.325.26-.78.26-.845-.26-.845-.26l-4.94-2.86z",
    className: "usaa_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.217 11.57.39 1.755 3.965 2.34s.455.26.845.26.845-.325.845-.325v-1.495s-.325.26-.78.26-.845-.26-.845-.26l-4.42-2.535z",
    className: "usaa_svg__st1"
  }))));
};
export default SvgUsaa;